import {useMemo} from 'react';

import {
  type EventTriggeringConditionType,
  useFetchTriggerTemplateVariablesQuery,
} from '../../../../generated/graphql';
import {type TemplateValue} from '../TriggerEventTypes';

/**
 * Hook to fetch automation template variables for a given event type from the backend.
 */
export const useTriggerTemplateVariables = (
  eventType: EventTriggeringConditionType | undefined
): TemplateValue[] => {
  const {data} = useFetchTriggerTemplateVariablesQuery({
    variables: {
      eventType: eventType!,
    },
    skip: eventType == null,
    // Automation template variables are static data, so minimize refetching
    fetchPolicy: 'cache-first',
  });

  return useMemo(() => {
    return eventType == null ? [] : data?.triggerTemplateVariables || [];
  }, [eventType, data]);
};
